import { render, staticRenderFns } from "./unit-markdown.vue?vue&type=template&id=9e19608e&scoped=true"
import script from "./unit-markdown.vue?vue&type=script&lang=js"
export * from "./unit-markdown.vue?vue&type=script&lang=js"
import style0 from "./unit-markdown.vue?vue&type=style&index=0&id=9e19608e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e19608e",
  null
  
)

export default component.exports